<template>
    <b-card header="Portabilidad" id="portabilidad">
        <b-form-group label="¿Deseas portar tu número? *">

            <b-button-group v-if="type == 'btn'">
                <b-button v-for="type in purchaseTypes" :disabled="isMultiPurchase" :key="type.key"
                    :variant="(form.purchaseType === type.key ? 'primary' : 'outline-primary')"
                    @click="form.purchaseType = type.key">
                    {{ type.label }}
                </b-button>
            </b-button-group>

            <b-form-radio-group class="b-form-group" v-if="type == 'radio'" v-model="form.purchaseType">
                <b-form-radio v-for="type in purchaseTypes" :key="type.key" :value="type.key"
                    :disabled="isMultiPurchase">
                    {{ type.label }}
                </b-form-radio>
            </b-form-radio-group>

            <b-jumbotron v-if="form.purchaseType === 'nirChange'" class="mt-3">

                <strong>{{ getHintForPurchaseType(form.purchaseType) }}</strong>

                <b-row algin-v="start" class="mt-2">
                    <b-col md="3" sm="12">
                        <b-form-group>
                            <b-form-select v-model="form.zone" placeholder="Selecciona la zona con el que deseas empieze tu nuevo número." required>
                                <option v-for="zona in [2, 3, 4, 5, 6, 7, 8, 9]" :key="zona" :value="zona">
                                    Zona {{ zona }}
                                </option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <small v-if="purchaseTypes.find(type => type.key === form.purchaseType).desc" class="text-muted">
                    {{ purchaseTypes.find(type => type.key === form.purchaseType).desc }}
                </small>
            </b-jumbotron>

            <b-jumbotron v-if="form.purchaseType === 'portability'" class="mt-3">
                <!-- <div > -->
                    <strong>{{ getHintForPurchaseType(form.purchaseType) }}</strong>

                    <b-row algin-v="start" class="mt-2">
                        <b-col md="5" sm="12">
                            <b-form-group>
                                <b-form-input v-model="form.numberToPort" type="text" maxlength="10"
                                    placeholder="Numero a portar" required>
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group>
                                <b-form-input v-model="form.nip" type="text" maxlength="10" placeholder="Ingresa tu NIP"
                                    required>
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                <!-- </div> -->
            </b-jumbotron>

            
            
            <b-jumbotron v-if="isMultiPurchase" class="mt-3">
                Al comprar varias líneas podrás actualizar su Lada y gestionar su portabilidad desde tu gestor de
                números BlackFon®
            </b-jumbotron>

            <p v-else-if="form.purchaseType === 'newLine'" class="mt-3 callout">
                {{getHintForPurchaseType(form.purchaseType)}}
            </p>

            <div class="debug" v-if="debug">
                <code><pre>{{ form }}</pre></code>
            </div>

            <!-- <b-button-group>
                <b-button :variant="(form.portNumber === true ? 'primary' : 'outline-primary')"
                    @click="form.portNumber = true">
                    Si, deseo portar mi número
                </b-button>
                <b-button :variant="(form.portNumber === false ? 'primary' : 'outline-primary')"
                    @click="form.portNumber = false">
                    No deseo portar
                </b-button>
                <b-button :variant="(form.portNumber === false ? 'primary' : 'outline-primary')"
                    @click="form.portNumber = false">
                    No deseo portar
                </b-button>
            </b-button-group> -->
        </b-form-group>
    </b-card>
</template>

<script>
import contrataYa from './contrataYa';
export default {
    name: 'portabilidad',
    props: {
        debug: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'radio' // btn | radio
        }
    },
    data() {
        return {
            purchaseTypes: contrataYa.purchaseTypes,
            form: contrataYa.workingData,
        }
    },
    computed: {
        isMultiPurchase() {
            return (this.form.numberOfLines > 1);
        }
    },
    methods: {
        getHintForPurchaseType(key) {
            const type = this.purchaseTypes.find(type => type.key === key);
            return type ? type.hint : '';
        }
    },
    beforeMount() {
        if (this.isMultiPurchase)
            this.form.purchaseType = 'newLine';

    }
}
</script>

<style lang="scss">
#portabilidad {
    .b-form-group {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .b-form-radio {
            // margin-bottom: 1em;
        }
    }
}
</style>